import { TaskPriority } from '@demind-inc/core';
import { getCssVariable } from '../../utils/styles/styles';

export const getPriorityColor = (priority?: TaskPriority) => {
  if (priority === 'high') return getCssVariable('--color-red-base') || '#F34720';
  if (priority === 'medium') return '#FF9F0A';
  if (priority === 'low') return getCssVariable('--color-yellow-base') || '#FDC913';
  return getCssVariable('--color-gray-base') || '#b5b5bc';
};
